import {TimeSpan} from "@sparkware/app-utils";

export const SESSION_TIMER_INCREMENT_INTERVAL = TimeSpan.fromSeconds(5);
export const SESSION_TIMER_HEARTBEAT_INTERVAL_LOW_RATE = TimeSpan.fromMinutes(1);
export const SESSION_TIMER_HEARTBEAT_INTERVAL_HIGH_RATE = TimeSpan.fromSeconds(15);